import { useState, useEffect } from 'react';
import {
  Divider,
  Card,
  CardHeader,
  Container,
  Grid,
  Tab,
  Box,
} from '@mui/material';
import axios from 'axios';
import { url } from 'src/Helpers/utils/Constant';
import { ICompanyBusinessLicense } from 'src/Types/module/UpdateRequest/RequestBusinessLicense';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import BusinessLicenseIndex from './BusinessLicenseIndex';
const RequestBusinessLicenseInfo = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [businessLicenseInfo, setbusinessLicenseInfo] = useState<
    ICompanyBusinessLicense[]
  >([]);
  const [value, setValue] = useState('pending');

  useEffect(() => {
    setIsLoading(true);
    try {
      (async function () {
        const { data } = await axios.get(
          `${url}/api/atab/member-company/update-request/member/business-license?status=${value}`
        );

        if (data.success) {
          setbusinessLicenseInfo(data.data);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })();
    } catch (error) {
      setIsLoading(false);
    }
  }, [value]);

  return (
    <Container sx={{ mt: 4 }} maxWidth='xl'>
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='stretch'
        spacing={3}
      >
        <Grid item xs={12}>
          <TabContext value={value}>
            <Card>
              <CardHeader
                title='Business License information'
                action={
                  <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderColor: 'divider' }}>
                      <TabList
                        onChange={(_event, newValue) => setValue(newValue)}
                        aria-label='lab API tabs example'
                      >
                        <Tab label='Pending' value='pending' />
                        <Tab label='Approved' value='approved' />
                        <Tab label='Rejected' value='rejected' />
                      </TabList>
                    </Box>
                  </Box>
                }
              />
              <Divider />
              <TabPanel value='pending'>
                <BusinessLicenseIndex
                  isLoading={isLoading}
                  businessLicenseInfo={businessLicenseInfo}
                />
              </TabPanel>
              <TabPanel value='approved'>
                <BusinessLicenseIndex
                  isLoading={isLoading}
                  businessLicenseInfo={businessLicenseInfo}
                />
              </TabPanel>
              <TabPanel value='rejected'>
                <BusinessLicenseIndex
                  isLoading={isLoading}
                  businessLicenseInfo={businessLicenseInfo}
                />
              </TabPanel>
              {/* <Box p={2}>
              <TablePagination
                component='div'
                count={companyInfo?.length}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleLimitChange}
                page={page && page}
                rowsPerPage={limit}
                rowsPerPageOptions={[25, 50, 75, 100]}
              />
            </Box> */}
            </Card>
          </TabContext>
        </Grid>
      </Grid>
    </Container>
  );
};

export default RequestBusinessLicenseInfo;
